/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabView, TabPanel } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import SubModule from "./submodule-management";
import Module from "./module-management";
import Action from "./action-management";
import Api from "./api-management";
import SettingManagement from "./setting-management";
// import CompletedTransaction from "./completed-transaction";

const cookies = new Cookies();

const ModuleSubModuleManagement = ({
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let moduleAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "947c949c-67e0-4e13-992b-5214309a3df0"
  );

  let subAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "1cd870ee-1d9d-4c1c-9371-51de3952241c"
  );
  let actionAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "8db54b87-388f-4ec7-b22a-49a7ade30a96"
  );
  let apiAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "973b59ce-1704-456f-86d3-e3867a407fca"
  );

  return (
    <DashboardLayout>
    <DashboardNavbar />

    <MDBox pt={2} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          {moduleAccess && subAccess && actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module /> {/* Assuming this is your "Module" component */}
              </TabPanel>
              <TabPanel header="Sub-Module">
                <SubModule /> {/* Assuming this is your "User Roles" component */}
              </TabPanel>
              <TabPanel header="Action">
                <Action /> {/* Assuming this is your "User Details" component */}
              </TabPanel>
              <TabPanel header="API">
                <Api /> {/* Assuming this is your "View Access" component */}
              </TabPanel>
            </TabView>
          ) : !moduleAccess && subAccess && actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          ) : moduleAccess && !subAccess && actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          ) : moduleAccess && subAccess && !actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          ) : moduleAccess && subAccess && actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
            </TabView>
          ) : !moduleAccess && !subAccess && actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          ) : !moduleAccess && subAccess && !actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          )
          
          : !moduleAccess && subAccess && actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
            </TabView>
            
          ) 
          
          : moduleAccess && !subAccess && !actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
            
          ) 
          
          : moduleAccess && subAccess && !actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
            </TabView>
            
          ) 
          
          : !moduleAccess && !subAccess && !actionAccess && apiAccess ? (
            <TabView>
              <TabPanel header="API">
                <Api />
              </TabPanel>
            </TabView>
          ) : moduleAccess && !subAccess && !actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
            </TabView>
          ) : moduleAccess && !subAccess && actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Module">
                <Module />
              </TabPanel>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
            </TabView>
          ) 
          
          : !moduleAccess && subAccess && !actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Sub-Module">
                <SubModule />
              </TabPanel>
            </TabView>
          ) : !moduleAccess && !subAccess && actionAccess && !apiAccess ? (
            <TabView>
              <TabPanel header="Action">
                <Action />
              </TabPanel>
            </TabView>
          )
          
          : !moduleAccess && !subAccess && !actionAccess && !apiAccess ? (
            <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
              No Modules Access
            </h4>
          ) : null}
        </Grid>
      </Grid>
    </MDBox>
  </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(ModuleSubModuleManagement);
